import { useEffect, useState } from "react";

import { useAuthenticationDataContext } from "../../Helpers/AuthenticationDataProvider";
import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";

import { CurrentUserResponse} from "../../pages/EditCurrentProfile/EditCurrentProfile.model"
import { ContactSettings, UserSettings } from "./UserSettings.model";

export const useUserSettings = () => {
  const { userId } = useAuthenticationDataContext();
  const { get, put } = useFetchWrapper();
  const [currentUser, setCurrentUser] = useState<CurrentUserResponse>();
  const [contactOptions, setContactOptions] = useState<ContactSettings>();
  const [editEmail, setEditEmail] = useState(false);
  const [email, setEmail] = useState<string>();
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);

  useEffect(() => {
    getCurrentUser();
    getSettings();
  }, []);

  const getCurrentUser = async () => {
    const response: HttpResponse<CurrentUserResponse> = await get(`/user/profile/${userId}`);
    if (response.parsedBody) {
      const user = response.parsedBody;
      setCurrentUser(user);
    }
  }

  const getSettings = async () => {
    const response: HttpResponse<UserSettings> = await get(`/user/settings`);
    if (response.parsedBody) {
      const { email, includeInNetwork, includeInSearch } = response.parsedBody;
      setContactOptions({ includeInNetwork, includeInSearch });
      setEmail(email);
    }
  }

  const toggleEditEmail = () => {
    setEditEmail(!editEmail);
  }

  const togglePasswordPopup = () => {
    setShowPasswordPopup(!showPasswordPopup);
  }

  const updateEmail = async () => {
    await put('/user/settings/email', { email });
  }

  const updateSettings = async (contactSettings: ContactSettings) => {
    setContactOptions(contactSettings);
    const response = await put('/user/settings', contactSettings);
    if (response) getSettings();
  }

  return {
    setEmail,
    state: { contactOptions, currentUser, editEmail, email, showPasswordPopup },
    toggleEditEmail,
    togglePasswordPopup,
    updateEmail,
    updateSettings,
  }
}